// src/games/Memory.tsx
import React from "react";

type MemoryProps = {
  onQuit: () => void;
};

export default function Memory({ onQuit }: MemoryProps) {
  return (
    <div className="container" style={{ position: "relative" }}>
      {/* Bouton Quitter */}
      <button
        onClick={onQuit}
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          background: "transparent",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
        }}
        title="Quitter le jeu"
      >
        ❌
      </button>

      <h2>🧠 Memory ChatGPT</h2>
      <p>Ce jeu arrivera bientôt !</p>
    </div>
  );
}
